import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcSettingsHandler } from './rpc-settings-handler';
import { RpcSettings, RpcSettingsKey, RpcSettingsResult } from './rpc-settings-model';

/**
 * Rpc settings request subject interface.
 */
export interface RpcSettingsSubject extends Subject<DeferredData<RpcSettings, RpcSettingsResult>> {}

/**
 * The class to implement RpcLog with Subject server.
 */
export class RpcSettingsSubjectServer extends RpcSubjectServer<RpcSettings, RpcSettingsResult> implements RpcSettingsHandler {
    /**
     * Initializes a new instance of the RpcSettingsSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcSettingsKey.command);
    }

    /**
     * The handler to respond a request for RpcLog call.
     *
     * @param data The RPC log record object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcSettings): Promise<RpcSettingsResult> {
        return this.processNextForSubject(RpcSettingsKey.command, data);
    }
}
